// ============================================================================
// CHARGE TYPE ENDPOINTS
// ============================================================================
// URL builders for the ChargeType lookup (read-only).
// Backend controller: ChargeTypesController → /api/v1/ChargeTypes

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/ChargeTypes';

export const chargeTypeEndpoints = {
  /** GET /api/v1/ChargeTypes — full list (small lookup, not paginated) */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/ChargeTypes/{id} */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/ChargeTypes/code/{code} */
  getByCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /** Raw path for buildEndpointWithQuery */
  basePath: () => BASE_PATH,
} as const;

export default chargeTypeEndpoints;
